import React, { useState } from 'react'
import classnames from 'classnames'
import get from 'lodash/get'

import '../styles/form.scss'

function FormInput({
  label,
  className,
  classNameContainerWrapper,
  classNameContainer,
  classNameLabel,
  classNameInput,
  defaultType = 'text',
  children,
  disabledMarginBottom,
  error,
  isSettings,
  isConfirmCode,
  ...props
}) {
  const [type, setType] = useState(defaultType)
  const handleEyeClick = () => setType(type === 'password' ? 'text' : 'password')
  return (
    <div
      className={classnames(
        'account-form',
        { 'account-form--disabled-margin-bottom': disabledMarginBottom },
        className
      )}>
      <div className={classnames('account-form__container-wrapper', classNameContainerWrapper)}>
        <label className={classnames('account-form__container', classNameContainer)}>
          <span
            className={classnames(
              'account-form__label',
              { 'account-form__label--settings': isSettings },
              { 'account-form__label--confirm-code': isConfirmCode },
              classNameLabel
            )}>
            {label}
          </span>
          <div className="account-form__input-wrapper">
            <input
              className={classnames(
                'account-form__input',
                { 'account-form__input--error': Boolean(error) },
                { 'account-form__input--settings': isSettings },
                { 'account-form__input--password': defaultType === 'password' },
                { 'account-form__input--confirm-code': isConfirmCode },
                classNameInput
              )}
              type={type}
              {...props}
            />
            {defaultType === 'password' && (
              <div
                className={classnames('account-form__eye', { 'account-form__eye--active': type === 'text' })}
                onClick={handleEyeClick}
              />
            )}
          </div>
        </label>
        {children}
      </div>
      {error && (
        <div className="account-form__error account-form__error--input account-form__error--settings">
          {get(error, 'message') ? get(error, 'message') : String(error)}
        </div>
      )}
    </div>
  )
}

export default FormInput
